import { FormControl, MenuItem, Typography } from "@mui/material";
import { isFulfilled } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../app/hooks";
import {
  DesktopDatePickerLight,
  SelectLight,
  TextFieldLight,
} from "../../../common/components/styled/styled";
import { CREDIT_INVOICE_REASONS } from "../constants";
import { PaymentTerm } from "../invoiceAPI";
import { fetchPaymentTerms } from "../invoiceDetailedSlice";
import { MarginBox } from "../styled";
import { CreditInvoiceInfo } from "./NewCreditInvoiceDialog";
import { leadingZerosDateFormat } from "../../../common/helpers/formatDateTime";

interface Props {
  creditInvoiceInfo: CreditInvoiceInfo;
  updateData: (name: string, value: any) => void;
}

export const NewCreditInvoiceForm = ({
  creditInvoiceInfo,
  updateData,
}: Props) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(["common", "invoices"]);

  const [paymentTermOptions, setPaymentTermOptions] = useState<PaymentTerm[]>(
    [],
  );

  useEffect(() => {
    dispatch(fetchPaymentTerms({})).then(
      (action) =>
        isFulfilled(action) &&
        setPaymentTermOptions(action.payload.paymentTerms),
    );
  }, [dispatch]);

  return (
    <>
      <FormControl fullWidth>
        <MarginBox>
          <Typography>{t("invoices:selectReason")}</Typography>
        </MarginBox>
        <SelectLight
          value={creditInvoiceInfo.reason}
          label={null}
          onChange={(e: any) => updateData("reason", e.target.value)}
          size="small"
        >
          {CREDIT_INVOICE_REASONS.map((option) => (
            <MenuItem key={option} value={option}>
              {t(`invoices:${option}`)}
            </MenuItem>
          ))}
        </SelectLight>
      </FormControl>
      {creditInvoiceInfo.reason === "other" ? (
        <FormControl fullWidth>
          <MarginBox>
            <Typography>{t("common:description")}</Typography>
          </MarginBox>
          <TextFieldLight
            value={creditInvoiceInfo.freeText}
            label={null}
            onChange={(e: any) => updateData("freeText", e.target.value)}
            size="small"
          />
        </FormControl>
      ) : null}
      <FormControl fullWidth>
        <MarginBox>
          <Typography>{t("invoices:defineNewDate")}</Typography>
        </MarginBox>
        <DesktopDatePickerLight
          format={leadingZerosDateFormat}
          label={null}
          value={creditInvoiceInfo.invoiceValueDate}
          onChange={(newValue: any) =>
            !!newValue && updateData("invoiceValueDate", newValue)
          }
          slotProps={{ textField: { size: "small" } }}
        />
      </FormControl>
      <FormControl fullWidth>
        <MarginBox>
          <Typography>{t("invoices:selectPaymentTerm")}</Typography>
        </MarginBox>
        <SelectLight
          value={creditInvoiceInfo.paymentTermDays}
          label={null}
          onChange={(e: any) => updateData("paymentTermDays", e.target.value)}
          size="small"
        >
          {paymentTermOptions.map((option) => (
            <MenuItem key={option.days} value={option.days}>
              {option.days} {t("common:days")}
            </MenuItem>
          ))}
        </SelectLight>
      </FormControl>
    </>
  );
};
